module.exports = __webpack_public_path__ + "static/media/star-active.152d7b5c.svg";